import { Alert } from '@mui/material'
import { formatDuration } from '$func/time'
import { t } from '$i18n'

type Props = {
  scope?: string
  remainingMillis: number
}

/** A persistent, actionable alternative to a transient rate-limit snackbar. */
export function AuthThrottleWarningBanner({ scope, remainingMillis }: Props) {
  if (remainingMillis <= 0) return null

  const messageKey =
    scope === 'phone' ? 'signin.throttle.phone' : 'signin.throttle.general'

  return (
    <Alert
      severity="warning"
      variant="filled"
      sx={{ mt: 2, mb: 2, borderRadius: 2, alignItems: 'flex-start' }}
    >
      {t(messageKey, { x: formatDuration(remainingMillis) })}
    </Alert>
  )
}
